<template>
    <div class="max_main_box" :style="'background-image: url(' + activity_background + ')'">
        <headerNoticeBox></headerNoticeBox>

        <template v-if="isEmpty(activity_banner)">
            <div class="line_space space10"></div>
            <div class="line_space space10"></div>
            <div class="line_space space7"></div>
        </template>
        <template v-else>
            <div class="banner_swiper_box">
                <swiper :options="banner_swiper_option" ref="mySwiper">
                    <!-- slides -->
                    <template v-for="(one,index) in activity_banner">
                        <swiper-slide :key="index">
                            <div class="banner img img_cover" :style="'background-image:url(' + one.img_url + ')'"></div>
                        </swiper-slide>
                    </template>
                </swiper>
            </div>
        </template>
        <div class="content_box">
            <div class="menu_list">
                <div class="menu_line" @click="routerToName('reserveRegisterStart', {activity_id})">预约登记/现场登记</div>
                <div class="menu_line" @click="routerToName('reserveRecord', {activity_id})">预约记录/入馆凭证</div>
            </div>
            <div class="line_space space8"></div>
            <div class="btn_list">
                <div class="btn_line" @click="scanQRcode">
                    <div class="icon icon_scan"></div>
                    <div class="txt">扫一扫入馆</div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import headerNoticeBox from '../../components/headerNoticeBox'
    import mixins_reserve from '../../mixins/reserve'
    import * as wapi from "../../api/wechat";

    export default {
        name: "index"
        ,mixins: [mixins_reserve]
        ,components: {headerNoticeBox}
        ,data: function () {
            return {
                banner_swiper_option:{
                    slidesPerView: 'auto',
                    loop: true,
                    centeredSlides: true,
                    autoplay: {
                        delay: 5000
                    }
                }
                ,activity_background: ''
                ,activity_banner: ''
            }
        }
        ,created: function() {
            this.$ls('activity_id', this.activity_id);
            this.getActivityBanner0();
            this.getActivityBanner1();
        }
        ,mounted: function() {
            wapi.wxConfig();
        }
        ,methods: {
            scanQRcode: function () {
                this.$wx.config({
                    jsApiList: ['scanQRCode'] // 必填，需要使用的JS接口列表
                });
                this.$wx.scanQRCode({
                    needResult: 0, // 默认为0，扫描结果由微信处理，1则直接返回扫描结果，
                    scanType: ["qrCode"], // 可以指定扫二维码还是一维码，默认二者都有
                    success: function (res) {
                        console.log(res);
                    }
                });
            }
        }
    }
</script>

<style lang="scss" scoped>
    .content_box{
        width: 100%;

        .menu_list{

            .menu_line{
                width: 5.4rem;
                height: 1.2rem;
                line-height: 1.2rem;
                border-radius: .12rem;
                border: .02rem solid $color_bdr_green0;
                background-color: $color_bg_green0;
                margin: 0 auto;
                font-size: .36rem;
                color: $color_green0;
                text-align: center;

                + .menu_line{
                    margin-top: .4rem;
                }
            }
        }
        .btn_list{

            .btn_line{
                display: flex;
                justify-content: center;
                align-items: center;
                width: 5.4rem;
                height: 1.2rem;
                line-height: 1.2rem;
                border-radius: 1.2rem;
                background-color: $color_bg_green1;
                margin: 0 auto;
                color: #fff;
                text-align: center;

                .icon{
                    width: .66rem;
                    height: .66rem;
                    margin-right: .2rem;
                }
                .txt{
                    font-size: .42rem;
                    font-weight: bold;
                }
            }
        }
    }
</style>